const showMoreText = document.getElementById('showMoreText');
const more = document.getElementById('more');

if (more) {
    more.addEventListener('click', function() {
        more.classList.toggle('collapsed');
        showMoreText.classList.toggle('collapsed');
    });
}

